import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { MainService } from "../../../../app.service";
import { DtaContent } from "../../interfaces/dta-content";
import { DtaResponse } from "../../interfaces/dta-response";

@Injectable({
  providedIn: "root",
})
export class DependencyTrackDtaService {
  constructor(
    private httpClient: HttpClient,
    private mainsService: MainService
  ) {}

  postDtaChat(content: DtaContent): Observable<DtaResponse> {
    return this.httpClient.post<DtaResponse>(
      `/dependency-tracker-extractor/v1/dta/chat`,
      content,
      this.mainsService.httpOptions
    );
  }
}
